import { FormGroup, ValidationErrors } from "@angular/forms";
import * as _ from "lodash";

export abstract class FormComponent {
    constructor(readonly formGroup: FormGroup) { }

    public numberCharInput(formControl: string): number {
        return this.formGroup.controls[formControl].value.length;
    }

    public getError(formControl: string): ValidationErrors | null {
        return this.formGroup.controls[formControl].errors;
    }

    public isInputValid(formControl: string): boolean {
        return _.isNil(this.formGroup.controls[formControl].errors);
    }

    public displayError(formControl: string): boolean {
        return (this.formGroup.controls[formControl].status === 'INVALID') && this.formGroup.controls[formControl].touched;
    }
}